// Former inline styles of CommonDrawer.tsx; values copied unchanged.

.backSlot {
  min-width: 24px;
}

.closeButton {
  cursor: pointer;
  display: flex;
}
